// Mock data for Northern Treat website

export const mockMenuItems = {
  thali: [
    {
      name: "Daal Baati Churma Thali",
      price: 249,
      image: "/images/thali/DaalBaatiChurmaThali.png",
      description: "1 Daal Bowl, 4 Baati, Gatte ki Sabji, Churma, Hari Chatni, Salad"
    },
    {
      name: "Chole Bhature Thali",
      price: 199,
      image: "/images/thali/Chole Bhature.png",
      description: "2 Bhature, Delhi Style Punjabi Chole, Salad"
    },
    {
      name: "Bread Kulche with Chole",
      price: 199,
      image: "/images/thali/Bread Kulche with Chole Thali.png",
      description: "2 Bread Kulche, Delhi Style Punjabi Chole, Salad"
    }
  ],
  sabji: [
    {
      name: "Creamy Malai Kofta",
      price: 299,
      image: "/images/sabji/Creamy Malai Kofta.png",
      size: "1 Big Bowl"
    },
    {
      name: "Gatte ki Sabji",
      price: 149,
      image: "/images/sabji/GatteKiSabji.png",
      size: "1 Big Bowl"
    },
    {
      name: "Matar Paneer",
      price: 299,
      image: "/images/sabji/Matar Paneer.png",
      size: "1 Big Bowl"
    },
    {
      name: "Punjabi Chole Masala",
      price: 249,
      image: "/images/sabji/Punjabi Chole Masala.png",
      size: "1 Big Bowl"
    },
    {
      name: "Rajasthani Ghee Aalo Pyaaj Sabji",
      price: 249,
      image: "/images/sabji/Rajasthani Aalo Pyaaj sabji.png",
      size: "1 Big Bowl"
    }
  ],
  mustTry: [
    {
      name: "Dahi Bhalla",
      price: 99,
      image: "/images/must try/Dahi Bhalle.png",
      quantity: "2 pieces"
    },
    {
      name: "Malpua with Rabri",
      price: 70,
      image: "/images/must try/Malpua with Rabdi.png",
      quantity: "2 pieces"
    },
    {
      name: "Shahi Tukda with Rabdi",
      price: 70,
      image: "/images/must try/Shahi Tukda.png",
      quantity: "2 pieces"
    }
  ],
  kulfi: [
    {
      name: "Rose Kulfi",
      price: 60,
      image: "/images/kulfi/kulfi-rose.jpg"
    },
    {
      name: "Mango Kulfi",
      price: 60,
      image: "/images/kulfi/kulfi-mango.jpg"
    },
    {
      name: "Mawa Ilaichi",
      price: 50,
      image: "/images/kulfi/kulfi-pistachio.jpg"
    },
    {
      name: "Tutti Fruiti",
      price: 50,
      image: "/images/kulfi/kulfi-tutti.jpg"
    }
  ]
};

export const mockTestimonials = [
  {
    name: "Namrata Yerunkar",
    text: "Kulfi's were super creamy flavourful n tasty with instant delivery 😊 Thank you Trapti.",
    rating: 5
  },
  {
    name: "Manjari Sharma",
    text: "I just had the pleasure of trying this homemade kulfi. It had that beautiful, authentic malai flavour with just the right hint of cardamom. Go for it!",
    rating: 5
  },
  {
    name: "Poonam",
    text: "Very tasty Malpua and Rabri Trapti, 👌👌👌 Perfect 😍 very very tasty.",
    rating: 5
  },
  {
    name: "Anu",
    text: "Thank You Trapti for Authentic and delicious Rajasthani thali we really enjoyed it 👍👍👍",
    rating: 5
  },
  {
    name: "Bhagyashri Paralkar",
    text: "Yes it was super tasty 😊",
    rating: 5
  }
];
